export enum SettingsCustomerPortalDataEventObjectsEnum {
  CREATE_PORTAL_CONTINUE = 'create_portal_continue',
  CONFIGURE = 'configure_portal',
}
